<template>
  <div class="row mb-2">
    <div class="col-12 order-1 col-sm-5 order-sm-0 col-lg-8">
      <div class="row" v-show="!is_authenticated || ($route.matched[0] && $route.matched[0].name !== 'Home')">
        <div class="col-12 text-center col-lg-6 text-sm-left" style="font-size: large;">
          <span v-if="current_server_time.hasOwnProperty('_isValid')">{{ current_server_time.format('h:mm:ss a') }}</span>
        </div>
        <div class="col-12 col-lg-6 text-center text-sm-left text-lg-center" style="font-size: large;">
          <span>
            Next Bell 
            <span v-if="schedule_info.next_bell_time._isValid === true">{{ formatted_bell.prep }}&nbsp;</span> 
          </span>
          <span v-if="schedule_info.next_bell_time._isValid === true">{{ formatted_bell.time }}</span>
          <span v-else>N/A</span>
        </div>
      </div>
    </div>
    <div v-if="is_authenticated" class="col-12 col-sm-7 col-lg-4">
      <div class="d-flex justify-content-between justify-content-sm-end">
        <div class="text-sm-right">
          <b>{{ logged_in_user.username }}</b> at <span v-if="site_of_ip">{{ site_of_ip.name }}&nbsp;</span>
        </div>
        <button class="btn btn-sm btn-light my-auto ml-1" @click="logout()">
          <i class="fa fa-sign-out-alt fa-fw" aria-hidden="true"></i> 
          Logout
        </button>
      </div>
    </div>
    <div v-else class="col-12 text-right col-sm-7 col-lg-4 d-flex justify-content-between justify-content-sm-end align-items-start">
        <span v-if="site_of_ip" class="">{{ site_of_ip.name }}&nbsp;</span>
        <router-link :to="{ name: 'Login' }" class="btn btn-sm btn-light"><i class="fa fa-sign-in-alt fa-fw" aria-hidden="true"></i> Login </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment';

export default {
  data: function () {
    return {
      app_scoped_site_id: 1
    }
  },
  computed: {
    ...mapGetters({
      disabled_change_scoped_site: 'disabledChangeScopedSite',
      current_server_time: 'currentServerTime',
      is_authenticated: 'isAuthenticated',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId',
      schedule_info: 'scheduleInfo',
      site_of_ip: 'siteOfIp',
      sites: 'allSites',
    }),
    filtered_sites: function () {
      return this.sites.filter(site => this.hasSitePermission(site.site_id))
    },
    formatted_bell() {
      const today = moment().endOf('day');
      const week_from_today = moment(today).add(1, 'week');
      const next_bell = this.schedule_info.next_bell_time;

      if(next_bell > week_from_today) {
        return { prep: 'on', time: next_bell.format('MMM[.] Do [at] h:mm a') }
      }

      if(next_bell > today) {
        return { prep: 'on', time: next_bell.format('dddd [at] h:mm a') };
      }

      return { prep: 'at', time: next_bell.format('h:mm a') };
    }
  },
  watch: {
    scoped_site_id (newScopedSiteId, oldScopedSiteId) {
      this.app_scoped_site_id = newScopedSiteId
      this.$store.dispatch('getScheduleInfo')
    }
  },
  created () {
    this.$store.dispatch('getCurrentServerTime')
    this.$store.dispatch('getScheduleInfo')
    this.$store.dispatch('getSites')
    this.app_scoped_site_id = this.scoped_site_id
  },
  mounted () {
    this.interval = setInterval(this.time, 1000)
    this.interval_schedule_info = setInterval(this.get_schedule_info, 65000)
  },
  methods: {
    changeScopedSiteId () {
      this.$store.dispatch('changeScopedSiteId', this.app_scoped_site_id)
    },
    time () {
      this.$store.dispatch('getCurrentServerTime')
    },
    get_schedule_info () {
      this.$store.dispatch('getScheduleInfo')
    },
    logout () {
      this.password = ''
      this.username = ''
      this.$store.dispatch('logout')
    },
    hasSitePermission (siteId) {
      if ([1, 2].includes(this.logged_in_user.group_id)) {
        if (this.logged_in_user.assigned_site_ids.includes(siteId)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.interval_schedule_info)
  }
}
</script>
